export default "__VITE_ASSET__BT1qQqUh__"